export default "__VITE_ASSET__CzCk6Ink__"